function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  transform: "translate(10 8)"
}, React.createElement("rect", {
  width: 50,
  height: 38,
  x: 1,
  y: 1,
  fill: "#B3D4FF",
  stroke: "#0041C0",
  strokeWidth: 2,
  rx: 2
}), React.createElement("path", {
  fill: "#0041C0",
  fillRule: "nonzero",
  d: "M0 9h52v2H0z"
})), React.createElement("g", {
  transform: "translate(6 12)"
}, React.createElement("rect", {
  width: 50,
  height: 38,
  x: 1,
  y: 1,
  fill: "#B3D4FF",
  stroke: "#0041C0",
  strokeWidth: 2,
  rx: 2
}), React.createElement("path", {
  fill: "#0041C0",
  fillRule: "nonzero",
  d: "M0 9h52v2H0z"
})), React.createElement("g", {
  transform: "translate(2 16)"
}, React.createElement("rect", {
  width: 50,
  height: 38,
  x: 1,
  y: 1,
  fill: "#FFF",
  stroke: "#0041C0",
  strokeWidth: 2,
  rx: 2
}), React.createElement("path", {
  fill: "#0041C0",
  fillRule: "nonzero",
  d: "M4 17h24v2H4zM4 13h12v2H4zM0 9h52v2H0z"
}), React.createElement("circle", {
  cx: 5.5,
  cy: 5.5,
  r: 1.5,
  fill: "#0041C0",
  fillRule: "nonzero"
}), React.createElement("circle", {
  cx: 10.5,
  cy: 5.5,
  r: 1.5,
  fill: "#0041C0",
  fillRule: "nonzero"
}), React.createElement("circle", {
  cx: 15.5,
  cy: 5.5,
  r: 1.5,
  fill: "#0041C0",
  fillRule: "nonzero"
})), React.createElement("g", {
  transform: "translate(28 42)"
}, React.createElement("path", {
  fill: "#B3D4FF",
  stroke: "#0041C0",
  strokeWidth: 2,
  d: "M10 2.06L1.7 17h16.6L10 2.06z"
}), React.createElement("rect", {
  width: 2,
  height: 5,
  x: 9,
  y: 7,
  fill: "#0041C0",
  fillRule: "nonzero",
  rx: 1
}), React.createElement("circle", {
  cx: 10,
  cy: 14,
  r: 1,
  fill: "#0041C0",
  fillRule: "nonzero"
})));

var SvgServerError = function SvgServerError(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgServerError, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/serverError.d87a3c55.svg";
export { ForwardRef as ReactComponent };